import { render, staticRenderFns } from "./CStylesList.vue?vue&type=template&id=377f4dd8&"
import script from "./CStylesList.vue?vue&type=script&lang=js&"
export * from "./CStylesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports